import { Component, Injectable } from '@angular/core';
import { DispatcherModule } from '../dispatcher.module';
import { NgRedux } from '@angular-redux/store';
import { AppState } from '../state.model';
import { UserRoleActions } from './user-role-actions';
import { Role, UserRoles } from './user-role-state.model';

@Injectable({
  providedIn: DispatcherModule,
})
export class UserRoleDispatcher {
  /**
  * @require ngRedux Redux
  **/
  constructor(
    private ngRedux: NgRedux<AppState>
  ) { }

  /**
  * @functions setUpdateInfo Store the update info
  * @param updateRole flag to inidate the update calls
  * @param userRoles User email and roles in the search result
  * @param roleList List of available roles
  * @return void
  **/
  public setUpdateInfo(updateRole: string, userRoles: UserRoles, roleList: Array<Role>) {
    this.ngRedux.dispatch(UserRoleActions.setUpdateInfo(updateRole, userRoles, roleList));
  }
  /**
  * @method resetUpdate reset the update info
  * @return void
  **/
  public resetUpdate(): void {
    this.ngRedux.dispatch(UserRoleActions.resetUpdate());
  }

}
